export const linkText = "For more details, go to details";
